import axios from '@/utils/api'
import modulo from '@/utils/modulo'

const URL_CADASTROS_COLETIVOS = `${modulo.ARRECADACAO}/cadastrosColetivos`

const actions = {
  async findById ({ commit }, id) {
    const data = await axios({
      method: 'get',
      url: `${URL_CADASTROS_COLETIVOS}?id=${id}`,
      error: true
    })

    data.pecaTecnica.responsavel = data.pecaTecnica.dadoPecaTecnica.responsavel

    return data
  },

  async saveStep ({ commit }, { url, dados }) {
    const data = await axios({
      method: 'post',
      data: dados,
      url,
      error: true
    })

    return data
  },

  async find ({ commit }, filtro) {
    const data = await axios({
      method: 'post',
      url: `${URL_CADASTROS_COLETIVOS}/find`,
      data: filtro
    })
    return data
  },
  async findByFiltro ({ commit }, filtro) {
    const data = await axios({
      method: 'post',
      url: `${URL_CADASTROS_COLETIVOS}/findByFilter`,
      data: filtro
    })
    return data
  },

  finalizar ({ commit }, id) {
    return axios({
      method: 'get',
      url: `${URL_CADASTROS_COLETIVOS}/finalizar?id=${id}`,
      error: true
    })
  },

  tramitarProcessoArrecadacao ({commit}, cadastrosColetivo) {
    return axios({
      method: 'post',
      url: `${URL_CADASTROS_COLETIVOS}/tramitar`,
      data: cadastrosColetivo
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/arrecadacao/cadastroColetivo.js